import { render } from "./PaymentFailPage.vue?vue&type=template&id=d0d4794e"
import script from "./PaymentFailPage.vue?vue&type=script&lang=js"
export * from "./PaymentFailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__